// Switches the on-page error panel (app/includes/debug_errors.js) on for the owner's account only, so Matt
// can debug from his phone. The email is compared as a salted SHA-256 hash so it isn't in the bundle as text.

const SALT = 'coinholio-debug-v1';
const OWNER_HASH = 'bdba2287883e6cb0db05a1a47a5aab2e6a8c39ec88626702966ed8e5b6230a09';
const STORAGE_KEY = 'coinholio.debugErrors';

type DebugPanel = { report: (message: string) => void; render: () => void };

const panel = (): DebugPanel | undefined => (window as unknown as { __debugErrors?: DebugPanel }).__debugErrors;

export const saltedHash = async (email: string): Promise<string> => {
  const bytes = new TextEncoder().encode(SALT + email.trim().toLowerCase());
  const digest = await window.crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest), b => b.toString(16).padStart(2, '0')).join('');
};

// Called with the email from login, register and profile responses
export const rememberDebugUser = async (email: unknown): Promise<void> => {
  if (typeof email !== 'string' || !email || !window.crypto?.subtle) return;
  const isOwner = (await saltedHash(email)) === OWNER_HASH;
  try {
    if (isOwner) window.localStorage.setItem(STORAGE_KEY, '1');
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    return; // storage blocked: no panel
  }
  if (isOwner) panel()?.render();
};

export const reportError = (message: string): void => panel()?.report(message);
